package org.catharsis.spendtel.di

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.FirebaseAuth
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.firestore.FirebaseFirestore
import dev.gitlive.firebase.firestore.firestore
import dev.gitlive.firebase.storage.FirebaseStorage
import dev.gitlive.firebase.storage.storage
import org.catharsis.spendtel.core.api.AuthTokenProvider
import org.catharsis.spendtel.core.api.AuthenticationRepo
import org.catharsis.spendtel.core.api.ExpenseReportRepo
import org.catharsis.spendtel.core.api.SpendTelRepo
import org.catharsis.spendtel.core.api.SpendTelService
import org.catharsis.spendtel.core.api.StatementStorageRepo
import org.catharsis.spendtel.core.impl.AuthenticationRepoImpl
import org.catharsis.spendtel.core.impl.ExpenseReportRepoImpl
import org.catharsis.spendtel.core.impl.FirebaseAuthTokenProvider
import org.catharsis.spendtel.core.impl.SpendTelRepoImpl
import org.catharsis.spendtel.core.impl.SpendTelServiceImpl
import org.catharsis.spendtel.core.impl.StatementStorageRepoImpl
import org.catharsis.spendtel.core.network.createSpendTelHttpClient
import org.koin.core.module.Module
import org.koin.dsl.bind
import org.koin.dsl.module

internal val clientDataModule = module {
    single { Firebase.firestore }.bind<FirebaseFirestore>()
    single { Firebase.auth }.bind<FirebaseAuth>()
    single { Firebase.storage }.bind<FirebaseStorage>()

    single { createSpendTelHttpClient() }

    single { FirebaseAuthTokenProvider(get()) }.bind<AuthTokenProvider>()

    single { SpendTelServiceImpl(get(), get()) }.bind<SpendTelService>()
    single { SpendTelRepoImpl(get(), get()) }.bind<SpendTelRepo>()
    single { ExpenseReportRepoImpl(get()) }.bind<ExpenseReportRepo>()
    single { StatementStorageRepoImpl(get()) }.bind<StatementStorageRepo>()
    single { AuthenticationRepoImpl(get(), get(), get(), get(), get()) }.bind<AuthenticationRepo>()
}
